import { reqApiUrl,downloadUrl,openAccountPortfolioUrl } from '@/config/apiUrl.js'

export default {
  version: 1.0,
  timeout: 30000,
  apiPrefix: '',
  requestRetry: 4,
  requestRetryDelay: 800,
  tokenKey: 'accessToken',
  userInfoKey: 'userInfo',
  apiUrl: reqApiUrl,
  downloadUrl,
  corporation: '盈宝信息科技（广州）有限公司',
  siteName: '帮助中心',
  designSize: 375, // 设计稿宽度 375,建议使用375，可以和一些主流的ui库兼容。如vant
  openAccountPortfolioUrl,
}
